import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { MessagesSidebarLayout } from '@/messages/MessagesSidebarLayout';
import { EmptyState } from '@/messages/messagesStyles';
import { useSelfOnlyMessages } from '@/messages/useSelfOnlyMessages';

export const Route = createFileRoute(
  '/_app/_users/members/$memberId/messages/',
)({
  component: MessagesIndexRoute,
});

/**
 * The inbox landing.
 *
 * Legacy redirects this URL to the newest thread, or to compose when there are
 * none. That redirect isn't ported, since the two-pane layout already shows the
 * list beside the selected conversation. Legacy's empty-state copy is used.
 */
function MessagesIndexRoute() {
  const { t } = useTranslation();
  const { memberId } = Route.useParams();
  const navigate = useNavigate();
  const wrongMember = useSelfOnlyMessages(memberId);

  if (wrongMember) return null;

  return (
    <MessagesSidebarLayout
      onThreadClick={(thread) =>
        navigate({
          to: '/members/$memberId/messages/view/$threadId/',
          params: { memberId, threadId: `${thread.id}` },
        })
      }
    >
      <EmptyState>
        <NoThreads>
          <NoThreadsTitle>{t('wbs.no-new-messages-yet')}</NoThreadsTitle>
          <p>{t('profile.looks-like-you-haven')}</p>
        </NoThreads>
      </EmptyState>
    </MessagesSidebarLayout>
  );
}

const NoThreads = styled.div`
  max-width: 320px;
  text-align: center;

  p {
    font-size: 14px;
    margin: 0;
  }
`;

const NoThreadsTitle = styled.h3`
  color: var(--grey-1000);
  font-size: 18px;
  font-weight: 400;
  margin: 0 0 6px;
`;
